export * from './DocCertIcon';
export * from './DocCertIcon16Light';
export * from './DocCertIcon16Regular';
export * from './DocCertIcon16Solid';
export * from './DocCertIcon20Light';
export * from './DocCertIcon20Regular';
export * from './DocCertIcon20Solid';
export * from './DocCertIcon24Regular';
export * from './DocCertIcon24Solid';
export * from './DocCertIcon32Regular';
export * from './DocCertIcon64Regular';
